<span>{{ cellValue | formatCurrency }}</span>
